export default "<ng-content>        \r\n</ng-content>\r\n"